import { AdminDeposit } from '../models'
import type { ColumnsType } from 'antd/lib/table'
import {
  transformDate3,
  getAdminDepositUser,
  getAdminDepositCompany,
} from '../helpers'
import {
  CustomTitle,
  CustomHeaderText,
  AdminDepositTotalColumn,
  AdminDepositActionsColumn,
  AdminDepositMovileViewColumn,
} from 'src/components'

const adminDepositListColumns: ColumnsType<AdminDeposit> = [
  /* Deposits Data List */

  {
    title: () => <CustomHeaderText text='Deposits.Reference' />,
    responsive: ['sm'],
    sorter: (a: AdminDeposit, b: AdminDeposit) => a.internal_reference.length - b.internal_reference.length,
    render: (_, deposit) => <CustomTitle label={deposit.internal_reference} type={null} />
  },
  {
    title: () => <CustomHeaderText text='ValidateDeposits.DateCreated' />,
    responsive: ['sm'],
    sorter: (a: AdminDeposit, b: AdminDeposit) => {
      const dateA = new Date(a.created)
      const dateB = new Date(b.created)
      return dateA.getTime() - dateB.getTime()
    },
    render: (_, deposit) => <CustomTitle label={transformDate3(deposit.created)} type={null} />
  },

  {
    title: () => <CustomHeaderText text='Deposits.Total' isCentered />,
    responsive: ['sm'],
    sorter: (a: AdminDeposit, b: AdminDeposit) => a.total - b.total,
    render: (_, deposit) => <AdminDepositTotalColumn deposit={deposit} />
  },

  {
    title: () => <CustomHeaderText text='developers.User' isCentered />,
    responsive: ['sm'],
    sorter: (a: AdminDeposit, b: AdminDeposit) => getAdminDepositUser(a)?.length - getAdminDepositUser(b)?.length,
    render: (_, deposit) => <div className='centered'>
      <CustomTitle label={getAdminDepositUser(deposit)} type={null} />
    </div>
  },

  {
    title: () => <CustomHeaderText text='menuItems.Company' isCentered />,
    responsive: ['sm'],
    sorter: (a: AdminDeposit, b: AdminDeposit) => getAdminDepositCompany(a)?.length - getAdminDepositCompany(b)?.length,
    render: (_, deposit) => <div className='centered'>
      <CustomTitle label={getAdminDepositCompany(deposit)} type={null} />
    </div>
  },

  {
    title: () => <CustomHeaderText text='Deposits.Actions' isCentered />,
    responsive: ['sm'],
    render: (_, deposit) => <AdminDepositActionsColumn deposit={deposit} />
  },

  /* Mobile View */
  {
    title: () => <CustomHeaderText text='Summary.Deposit' isCentered />,
    responsive: ['xs'],
    sorter: (a: AdminDeposit, b: AdminDeposit) => {
      const dateA = new Date(a.created)
      const dateB = new Date(b.created)
      return dateA.getTime() - dateB.getTime()
    },
    render: (_, deposit) => <AdminDepositMovileViewColumn deposit={deposit} />
  },
]

export default adminDepositListColumns
